import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { BLUE_COLOR } from '../../styles/colors';
const DOT_ICON_CSS = css `
  color: ${BLUE_COLOR};
`;
export const ActionCostIndicator = () => {
    return _jsx("span", { css: DOT_ICON_CSS, children: "\u25CF" });
};
